// Shared toast string for "your form has issues" — shown alongside the
// inline field errors so the user notices something needs attention even
// if the failing field is below the fold.
export const SUBMIT_VALIDATION_TOAST =
  'Please fix the highlighted fields before continuing.';
